// A bedroom's beds (Oct 23: an owner has a king and two twins in the same
// room, and the form allowed one bed per room). `bedType` stays the room's
// main bed and `extraBeds` holds the rest, so listings saved before still
// read the same. Stored in properties.bedroom_details (jsonb), plain arrays
// only: it is embedded in prerendered pages.

export const BED_TYPES = ["King", "Queen", "Double", "Single", "Twin", "Bunk Bed", "Sofa Bed"];
export const MAX_BEDS_PER_ROOM = 4;

export interface BedroomDetail {
  bedType: string;
  extraBeds?: string[];
  ensuite: boolean;
  description: string;
}

export const newBedroom = (): BedroomDetail => ({ bedType: "Queen", ensuite: false, description: "" });

/** Every bed in the room, main bed first. */
export const bedsIn = (bd: Pick<BedroomDetail, "bedType" | "extraBeds">): string[] =>
  [bd.bedType, ...(Array.isArray(bd.extraBeds) ? bd.extraBeds : [])].filter(Boolean);

/** "King bed", "2 Twin beds", "King bed + 2 Twin beds", "Bunk bed". */
export function bedsLabel(beds: string[]): string {
  const counts = new Map<string, number>();
  for (const b of beds) counts.set(b, (counts.get(b) ?? 0) + 1);
  return [...counts]
    .map(([type, n]) => {
      const name = type.replace(/ bed$/i, "");
      return n > 1 ? `${n} ${name} beds` : `${name} bed`;
    })
    .join(" + ");
}
